var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group,index){return _c('mobile-menu-group',{key:index,class:{'mt-base': index > 0},attrs:{"id":group.TabIdName,"header-text":group.headerText,"items":group.items}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }